import {Box, Button, styled, Typography} from "@mui/material";
import React from "react";
import executiveSummaryBackground from "../../assets/executiveSummaryBackground.png";
import FileButton from "../TopSection/FileButton";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const filePlan = require("../../files/Business_Plan_AI_Investment_Platform.pdf");

// eslint-disable-next-line @typescript-eslint/no-var-requires
const filePresentation = require("../../files/Insight_Questor_PitchDeck.pptx");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const filePresentationPdf = require("../../files/Insight_Questor_PitchDeck.pdf");

const ExecutiveSummaryContainer = styled(Box)({
    width: "100%",
    position: "relative",
    borderImage: "linear-gradient(90deg, #05080c, #6d7985, #05080c) 100",
    borderBottom: "2px solid",
    background: `url(${executiveSummaryBackground}) no-repeat right 100%`,
    backgroundSize: "cover",
    padding: "10px 20px",
    boxSizing: "border-box",
    "@media(max-width: 768px)":{
        backgroundSize: "cover",
    }
});

const ExecutiveSummaryTitle = styled(Typography)({
    fontSize: "3.5rem",
    fontWeight: 400,
    color: "#FFFFFF",
    zIndex: 2,
    textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
    "@media(max-width: 768px)":{
        fontSize: "1.8rem",
    }
});

const ExecutiveSummaryContents = styled(Box)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    color: "#FFFFFF",
    "& li":{
        marginTop: "10px",
        fontSize: "1.8rem",
        fontWeight: 600,
        color: "#FFFFFF",
        zIndex: 2,
        textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
        "@media(max-width: 768px)":{
            fontSize: "1rem",
        },
        "& p":{
            fontWeight: 400,
            fontSize: "1.3rem",
        },
        "&>ul>li":{
            fontWeight: 400,
            fontSize: "1.3rem",
        }
    },
    "&>ul>li":{
        padding: "5px 5px 20px 15px",
        background: "rgba(0, 0, 0, 0.7)",
        borderRadius: "8px",
    },
    "&>ul":{
        display: "grid",
    },
    "@media(max-width: 768px)":{
        padding: 0,
        gridTemplateColumns: "1fr",
        "&>ul":{
            padding: 0,
        },
    },
});

export const DownloadButton = styled(Button)({
    cursor: "pointer",
    textTransform: "none",
    background: "linear-gradient(90deg,#df5b4f,#72313d)",
    borderRadius: "50px",
    padding: "10px 20px",
    height: "fit-content",
    display: "flex",
    gap: "10px",
    fontWeight: 800,
    color: "#FFF",
    fontSize: "1rem",
    transition: "background 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55), transform 0.5s ease-out",
    "&:hover":{
        background: "linear-gradient(45deg, #ffc371, #ff5f6d)",
        boxShadow:"0 0 15px #ffc371",
        transform: "scale(1.05)",
    },
    "@media(max-width: 768px)":{
        margin: "auto",
    }
});

const ExecutiveSummaryHeader = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});


const ButtonContainer = styled(Box)({
    display: "flex",
    gap: "120px",
    justifyContent: "center",
    textAlign: "center",
    "@media(max-width: 768px)":{
        gap: "20px",
        flexDirection: "column",
        alignItems: "end",
        bottom: "2vh",
    }
});

const ExecutiveSummary = ():JSX.Element => {
    
    const renderButtons = ():React.ReactNode => {
        return (
            <ButtonContainer>
                <FileButton title={"Pitch Deck"} file={filePresentation} filePdf={filePresentationPdf} size={"small"} fileTitle={"Insight_Questor_PitchDeck"} noRightSpace={true}/>
                <FileButton title={"Business Plan"} fileTitle={"Insight_Questor_Business_Plan"} file={filePlan} size={"small"} filePdf={filePlan} noRightSpace={true}/>
            </ButtonContainer>
        );
    };
    
    return (
        <ExecutiveSummaryContainer id={"executivesummary"}>
            <ExecutiveSummaryHeader>
                <ExecutiveSummaryTitle>Executive Summary:</ExecutiveSummaryTitle>
                {window.innerWidth > 768 && <>{renderButtons()}</>}
            </ExecutiveSummaryHeader>
            <ExecutiveSummaryContents>
                <ul>
                    <li>
                        Company Purpose:
                        <ul>
                            <li>
                                Provides AI-powered investment analysis accessible to everyone.
                            </li>
                            <li>
                                Converts complex data into straightforward insights for both beginners and experts.
                            </li>
                        </ul>
                    </li>
                    <li>
                        Market Opportunity:
                        <ul>
                            <li>
                                Capitalizes on a trillion-dollar fintech boom.
                            </li>
                            <li>
                                Addresses soaring demand for personalized, real-time financial guidance.
                            </li>
                        </ul>
                    </li>
                    <li>
                        Innovative Solution:
                        <ul>
                            <li>
                                Delivers real-time AI forecasts for stocks, crypto, and more.
                            </li>
                            <li>
                                Simplifies advanced data with easy-to-use dashboards.
                            </li>
                            <li>
                                Offers tiered subscriptions that fit any budget or skill level.
                            </li>
                        </ul>
                    </li>
                    <li>
                        Technological Edge:
                        <ul>
                            <li>
                               Utilizes machine learning and NLP for live, accurate forecasts.
                            </li>
                            <li>
                                Automates risk-balanced strategies tailored to each user’s goals.
                            </li>
                            <li>
                                Runs on scalable infrastructure designed for high-volume performance.
                            </li>
                        </ul>
                    </li>
                </ul>
                <ul>
                    <li>
                        Growth Strategy:
                        <ul>
                            <li>
                                Forms strategic alliances with brokerages and fintech leaders.
                            </li>
                            <li>
                                Expands into key markets in Europe, North America, and Asia.
                            </li>
                            <li>
                                Continuously evolves features with user feedback and market shifts.
                            </li>
                        </ul>
                    </li>
                    <li>
                        Investment Appeal:
                        <ul>
                            <li>
                                Serves a rapidly growing market for AI-driven finance tools.
                            </li>
                            <li>
                                Generates revenue via subscriptions, withdrawal fees, and B2B integrations.
                            </li>
                            <li>
                                Emphasizes financial education, building trust and long-term user loyalty.
                            </li>
                        </ul>
                    </li>
                    <li>
                        Invitation to Join:
                        <ul>
                            <li>
                                Seeking investors and co-founders passionate about democratizing finance.
                            </li>
                            <li>
                                Together, revolutionizing personal finance with AI for global impact and sustainable growth.
                            </li>
                        </ul>
                    </li>
                </ul>
            </ExecutiveSummaryContents>
            {window.innerWidth <= 768 && <>{renderButtons()}</>}
        </ExecutiveSummaryContainer>
    );
};

export default ExecutiveSummary;
